import KofiErfassungBelegFormMixin from "./KofiErfassungBelegFormMixin";

// @vue/component
export default {
  name: "KofiErfassungBelegForm",
  mixins: [
    KofiErfassungBelegFormMixin,
  ],
};
